<div (mouseenter)="showInfo()" (mouseleave)="showInfo()" (click)="persistInfo()" class="d-flex flex-column icon-container">
  <div *ngIf="isInfoVisible || isClicked" class="d-flex flex-column"
       [ngClass]="{'info-message-above': isAbove, 'info-message-below': !isAbove, 'centered': isCentered, 'not-centered': !isCentered}"
       [style.margin-top]="this.calculateMarginTop()">
    <div class="header">{{ header }}</div>
    <div class="content">{{ mainContent }}</div>
  </div>
  <div>
    <img [src]="(isInfoVisible || isClicked) ? 'assets/svg-icons/info-active.svg' : 'assets/svg-icons/info.svg'" alt="Info Icon" />
  </div>
</div>
